module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedication"
  }, [_c('b', [_vm._v("Penal Code, Article 178:"), _c('br')]), _vm._v(" Rehabilitation discharges additional penalties"), _c('br'), _vm._v("\n    as well as any other penal consequence of the sentence,"), _c('br'), _vm._v("\n    unless the law provides otherwise."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Penal Code, Article 179:")]), _c('br'), _vm._v("\n    Rehabilitation is acknowledged when five years have elapsed"), _c('br'), _vm._v("\n    from the date on which the sentence is served,"), _c('br'), _vm._v("\n    or discharged by some other means,"), _c('br'), _vm._v("\n    and the convict has given positive"), _c('br'), _vm._v("\n    and consistent proof of good conduct.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-162c8e3c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/GoodbyeKiss.vue
// module id = 72
// module chunks = 0